import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, Shield } from "lucide-react";
import { Link } from "react-router-dom";

const Privacy = () => {
  const { t } = useTranslation();

  const sections = [
    { title: t("legal_privacy_collect_title"), text: t("legal_privacy_collect_text") },
    { title: t("legal_privacy_use_title"), text: t("legal_privacy_use_text") },
    { title: t("legal_privacy_sharing_title"), text: t("legal_privacy_sharing_text") },
    { title: t("legal_privacy_security_title"), text: t("legal_privacy_security_text") },
    { title: t("legal_privacy_rights_title"), text: t("legal_privacy_rights_text") },
    { title: t("legal_privacy_contact_title"), text: t("legal_privacy_contact_text") },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="p-4 space-y-6 max-w-screen-xl mx-auto">
        <header className="flex items-center gap-4">
          <Button asChild variant="ghost" size="icon" className="shrink-0">
            <Link to="/profile">
              <ArrowLeft className="w-6 h-6" />
            </Link>
          </Button>
          <div className="flex items-center gap-3">
            <div className="bg-primary/10 p-3 rounded-xl text-primary">
              <Shield className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold">{t("legal_privacy_title")}</h1>
              <p className="text-sm text-muted-foreground">{t("legal_privacy_subtitle")}</p>
            </div>
          </div>
        </header>

        <Card className="p-5 space-y-4">
          <p className="text-sm text-muted-foreground">
            {t("legal_last_updated", { date: "2026-03-13" })}
          </p>
          <p className="text-sm">{t("legal_privacy_intro")}</p>
        </Card>

        {sections.map((section) => (
          <Card key={section.title} className="p-5 space-y-2">
            <h2 className="font-semibold">{section.title}</h2>
            <p className="text-sm text-muted-foreground">{section.text}</p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Privacy;
